import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-smsnotificationmangement',
  templateUrl: './smsnotificationmangement.component.html',
  styleUrls: ['./smsnotificationmangement.component.css']
})
export class SmsnotificationmangementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
